'use strict';

export default {
  SET_MENU(state, items) {
    state.menu = items;
    state.isLoading = false;
    },
    SET_GLOBAL_DOCS(state, items) {
        state.globalDocs = items;
    }
};